import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const returnSocialMediaArray = (icon) => {
  switch (icon) {
    case "instagram":
      return ["fab", "instagram"];
      break;
    case "facebook":
      return ["fab", "facebook"];
      break;
    case "twitter":
      return ["fab", "x-twitter"];
      break;
    case "linkedin":
      return ["fab", "linkedin"];
      break;
    case "youtube":
      return ["fab", "youtube"];
      break;
    case "pinterest":
      return ["fab", "pinterest"];
      break;
    default:
      return ["fas", "link"];
  }
};

const SocialMediaLink = ({ link, icon }) => {
  return (
    <div>
      <a href={link} rel="noreferrer" rel="noopener" target="_blank">
        <FontAwesomeIcon icon={returnSocialMediaArray(icon)} />
      </a>
    </div>
  );
};

export default SocialMediaLink;
